// extracted by mini-css-extract-plugin
module.exports = {"columnDivider":"ContainerBody_columnDivider__QWF6I","container":"ContainerBody_container__MseUi"};